import Head from 'next/head';
import { Progressbar } from '@/components/Progressbar';
import { ProgressbarCode } from '@/components/codeHighlights/ProgressbarCode';

const Page = () => {
  return (
    <>
      <Head>
        <title>Progressbar</title>
      </Head>

      <h1>Progressbar</h1>
      <Progressbar />

      <div className="mt-5">
        <h2>Alert HTML-Code Example</h2>
        <ProgressbarCode />
      </div>
    </>
  );
};

export default Page;
